import { ReferralMappingRosterType } from '../enums';
import { make } from './Model';
import { ReferralMappingOperation } from './ReferralMappingOperation';

export class ReferralMappingColumn {
  id = 0;

  sourceColumn = '';

  sourceColumnIndex = 0;

  targetColumn = '';

  defaultValue = '';

  rosterType: string = ReferralMappingRosterType.MEMBER.value;

  addToCandidate = false;

  candidateIndex = 0;

  operation: ReferralMappingOperation;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.operation = make(obj.operation, ReferralMappingOperation);
  }
}
